export const shareNarrationStatus = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  SENDING: "sending",
  TRANSFERRED: "transferred",
  CHECKING: "checking",
};

const BAYAN = "بیان";

export const isBayan = (text) => text === BAYAN;
